import React, { useEffect,useState } from "react";
import unsplash from "../api/unsplash";
import { useLocation, useNavigate } from "react-router-dom";
import { CSpinner } from "@coreui/react";
import {IconButton,Button,Dialog,DialogTitle,DialogContent,Grid,TextField,FormControl,InputLabel,Select,MenuItem,Popover,DialogActions,Box,Typography,Step,StepLabel,Stepper,CircularProgress,OutlinedInput,Card,CardContent} from '@mui/material';
import { DateTimePicker ,LocalizationProvider} from "@mui/lab";
import DateAdapter from '@mui/lab/AdapterMoment';
import { DataGrid, GridToolbar, itIT } from '@mui/x-data-grid';
import {Add, Circle} from "@mui/icons-material";
import GlobalSnackbar from "./Snackbar";
import moment from "moment-timezone";
import {Error,HourglassBottom} from '@mui/icons-material';

const columns = [
    { 
        headerName: '*',  
        field: 'clessidera',
        width: 50,
        headerAlign: 'center',
        align: 'center',
        sort: 'asc',
        
        renderCell: (params) =>{
    return (<div>
            {
  
                /*1*/ moment(params.row.Data).format("YYYY-MM-DD")< moment(new Date()).format("YYYY-MM-DD") && params.row.Esito<=1  ?<HourglassBottom sx={{color:"red"}}/>:(  params.row.Esito > 1?<HourglassBottom sx={{color:"green"}}/>:<HourglassBottom sx={{color:"orange"}}/>)
                }
            </div>)
    
        }
    
      },
  { 
    headerName: '**',  
    field: 'LimitazioniPassate',
    width: 50,
    headerAlign: 'center',
    align: 'center',
    sort: 'asc',
    
    renderCell: (params) =>{

        if(params.row.Esito === 3 || params.row.Esito === 4 ){
            return <div><Error sx={{color:"orange"}} /></div>
        }else{
            return ""
        }
        

    }

  },
  { 
    headerName: 'Idoneità',  
    field: 'Idoneita',
    width: 70,
    headerAlign: 'center',
    align: 'center',
    sort: 'asc',
    
    renderCell: (params) =>{

        if(params.row.Idoneita ===1){
            return <div><input type="checkbox" checked onClick={false}></input></div>
        }else{
            return <div><input type="checkbox" disabled onClick={false}></input></div>
        }
        

    }

    /*renderCell: (params) =>{

        if(params.row.Idoneita === 1){
            return <div><Error sx={{color:"orange"}} /></div>
        }else{
            return ""
        }
        
    }*/

  },
  {     
    field: 'Cliente',
    headerName: 'Cliente',
    width: 200,
   
    headerAlign: 'center',
    align: 'center',
    sort: 'asc'
  },
  {     
    field: 'ClienteAttuale',
    headerName: 'Cliente Attuale',
    width: 200,
    //flex:1,
    headerAlign: 'center',
    align: 'center',
    sort: 'asc'
  },
  {     
    field: 'LavoratoreCognome',
    headerName: 'Cognome',
    width: 200,
    //flex:1,
    headerAlign: 'center',
    align: 'center',
    sort: 'asc'
  },
  {     
    field: 'LavoratoreNome',
    headerName: 'Nome',
    width: 200,
    //flex:1,
    headerAlign: 'center',
    align: 'center',
    sort: 'asc'
  },
  {     
    field: 'Medico',
    headerName: 'Medico',
    width: 200,
    //flex:1,
    headerAlign: 'center',
    align: 'center',
    sort: 'asc'
  },
  {     
    field: 'Mansione',
    headerName: 'Mansione',
    width: 200,
    //flex:1,
    headerAlign: 'center',
    align: 'center',
    sort: 'asc'
  },
  {     
    field: 'Accertamenti',
    headerName: 'Accertamenti',
    width: 200,
    //flex:1,
    headerAlign: 'center',
    align: 'center',
    sort: 'asc'
  },
  {     
    field: 'EsitoDesc',
    headerName: 'Esito',
    width: 200,
    //flex:1,
    headerAlign: 'center',
    align: 'center',
    sort: 'asc'
  },
  {     
    field: 'TipoVDesc',
    headerName: 'Tipo',
    width: 200,
    //flex:1,
    headerAlign: 'center',
    align: 'center',
    sort: 'asc'
  },
  {     
    field: 'Data',
    headerName: 'Data',
    width: 200,
    //flex:1,
    headerAlign: 'center',
    align: 'center',
    sort: 'asc',
    renderCell: (params) =>{
        return <div>{moment(params.row.Data).format("DD-MM-YYYY HH:mm:SS")}</div>
    }
  },
  {     
    field: 'Scadenza',
    headerName: 'Scadenza',
    width: 200,
    //flex:1,
    headerAlign: 'center',
    align: 'center',
    sort: 'asc',
    renderCell: (params) =>{
        return <div>{moment(params.row.Scadenza).format("DD - MM - YYYY")}</div>
    }
  },
  {     
    field: 'CF',
    headerName: 'CF',
    width: 200,
    //flex:1,
    headerAlign: 'center',
    align: 'center',
    sort: 'asc'
  },
  {     
    field: 'UnitaProduttivaAllegato3B',
    headerName: 'Unità Produttiva',
    width: 200,
    //flex:1,
    headerAlign: 'center',
    align: 'center',
    sort: 'asc'
  },

];

const VisiteMediche = () => {
const [visite,setVisite] = useState();
const [mansioni,setMansioni] = useState();
const [medici,setMedici] = useState();
const [visitaSel,setVisitaSel] = useState([]);
const [esiti,setEsiti] =useState();
const [tipologiaVisita,setTipologiaVisita] =useState();
const location = useLocation();


useEffect(() => {// è un loop qui carico i dati 
    const fetchData = async () =>{
    
      try {
                  let response = await  unsplash.get('visiteMediche', {headers: {
                    'Authorization': `Bearer ${localStorage.getItem('jwt')}`}
                });
              setVisite(response.data.data);



              let responseEsiti =  await unsplash
              .get('esiti',{ headers: {
                'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
              }}
               );
               setEsiti(responseEsiti.data.data);
     
               let responseTipologiaVisita =  await unsplash
               .get('tipologiaVisita',{ headers: {
                 'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
               }}
                );
                setTipologiaVisita(responseTipologiaVisita.data.data);
     
                let responseMansioni=  await unsplash
                .get('mansioni',{ params:{id:-1},headers: {
                  'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
                }}
                 );
                
                 setMansioni(responseMansioni.data.data);

                 let responseMedici=  await unsplash
                 .get('medici',{ headers: {
                   'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
                 }}
                  );
                 
                  setMedici(responseMedici.data.data);         
                

      } catch (error) {
        console.error(error.message);
      }

    }

    fetchData();
   
  }, []);


const updateData = (visitaAggiornata,accertamenti) => {
visitaAggiornata.Data = moment(visitaAggiornata.Data).format("YYYY-MM-DD HH:mm:SS");
let accText = accertamenti.map(acc => acc.Descrizione);
visitaAggiornata.Accertamenti = accText.join()

let visiteTemp = [...visite];
const index = visiteTemp.findIndex(v => {
  return v.ID === visitaAggiornata.ID;
});

if (index > -1) {
  visiteTemp.splice(index, 1); // Rimuovo solo un elemento
  visiteTemp.splice(index, 0, visitaAggiornata); //serve per aggiungere in posizione index, l'elemento dopo lo 0. Lo 0 serve per non eliminare nulla
}
setVisite(visiteTemp);

}



return (
        <Grid item xs={12}>

        <Card>
          
          <CardContent>
          <DettaglioVisitaMedica  operation="new" title={"nuova visita medica"} visita={visitaSel} esiti={esiti} tipologiaVisita={tipologiaVisita} mansioni={mansioni} medici={medici} updateData={updateData}/>
        {visite?

 
         <Box
            sx={{
                height: 700,
                width: 1
            }}
            >
                
        <DataGrid 
        sx={{'.MuiDataGrid-columnHeaderCheckbox ': {display: 'none',},'.MuiDataGrid-cellCheckbox': {display: 'none',},fontSize:12}}
       
        components={{ Toolbar: GridToolbar }}
        localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
        rows={visite}
        columns={columns}
        getRowId={(row) => row.ID}
        pageSize={20}
        checkboxSelection
       
        onRowDoubleClick={ async (params,event)=> 
          {
    
            await setVisitaSel(params.row);
            document.getElementById("myDialog").click();
          }    
      }
                                      />
                                      </Box>
        
        
        
        :<center><CSpinner color="primary" />  </center>  
    
    }
              </CardContent>
              </Card>
              </Grid>
    
    
    )

}



export default VisiteMediche;


const DettaglioVisitaMedica = (props) => {

  const [open, setOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [accertamenti,setAccertamenti] = useState([]);
  const [selectionModel, setSelectionModel] = useState([]);
  const [required,setRequired] = useState({medico:false,data:false,tipo:false})
  const [openSnack, setOpenSnack] = useState(false);
  const [snack,setSnack] = useState({severity:"success",messaggio:"Salvataggio Effettuato correttamente",open:false});
  const [visita,setVisita] = useState();


  
  const handleCloseSnack = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnack(false);
  }
  
  const columns = [
      { field: 'Descrizione', headerName: 'Accertamento', width: 300 },
      { field: 'Scadenza', headerName: 'Scadenza', type:"date",width: 150,
      editable: true, 
        renderCell: (params) => ( 
  params.row.Scadenza?moment(params.row.Scadenza).format("DD/MM/YYYY"):""
    
      )  },
      { field: 'Importo', headerName: 'Importo €', type:"number", width: 120 ,editable: true,
      renderCell: (params) => ( 
        params.row.Importo?params.row.Importo:0
            ) 
    
    },
      { field: 'ImportoPassivo', headerName: 'ImportoPassivo €',type:"number", width: 150,editable: true,
      renderCell: (params) => ( 
        params.row.ImportoPassivo?params.row.ImportoPassivo:0
          
            )   }
    ];
  
  
  
  const loadAccertamenti = async(val,data) => {
  
    let responseAccertamenti =  await unsplash
          .get('accertamenti',{ params:{id:val,data:data},headers: {
            'Authorization': `Bearer ${localStorage.getItem("jwt")}`}});
     
           setAccertamenti(responseAccertamenti.data.data);
           setSelectionModel(responseAccertamenti.data.data.filter(acc => acc.VisitaMedica?acc.ID:null))

  } 
  


    const handleClickOpen = async () => {
     
        setVisita(props.visita)
        setAccertamenti([]);
       
        loadAccertamenti(props.visita.ID,moment(props.visita.Data).format("YYYY-MM-DD HH:mm:SS"));

      await setRequired({medico:false,data:false,tipo:false}); 
      setOpen(true);
      

    };

    const handleClose = () => {
      setOpen(false);
    };

  
    const handleSave = async() => {
   
      /*let req ={...required};
      let checkOk=true; //lo uso per controllare che tutto sia ok
      if(medicoSel ==="" || medicoSel ===null){
        req.medico =true;
        checkOk=false;
      }else{req.medico =false}  
      if(tipologiaSel ==="" || tipologiaSel ===null){
        req.tipo =true;
        checkOk=false;
      }else{req.tipo =false} 
  
      if(dataSel ==="" || dataSel ===null){
        req.data =true;
        checkOk=false;
      }else{req.data =false} 
  
      setRequired(req)
      if(checkOk){
   */

        props.updateData(visita,selectionModel);
        try{
        let response = await unsplash.put('visiteMediche',{visita:visita,accertamenti:selectionModel},
        { headers: {
          'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
        }}  ); 
        setSnack({severity:"success",messaggio:"Visita Medica modificata con successo"}) ; setOpenSnack(true);
      }catch{
        alert("errore");
      }
      
  
    }
  
  
  
  
  
    return (
      <div>
        <GlobalSnackbar severity={snack.severity} messaggio={snack.messaggio} openSnack={openSnack} handleCloseSnack={handleCloseSnack}/>
        <Button variant="outlined" style={{display:"None"}} onClick={handleClickOpen} id="myDialog">
        Nuovo
        </Button>
        <Dialog open={open} onClose={handleClose} fullWidth={true}
        maxWidth="lg"
          >
          <DialogTitle>{"Modifica Visita " + props.visita.LavoratoreCognome +" " + props.visita.LavoratoreNome +" - "+ props.visita.Cliente }</DialogTitle>
          <DialogContent>
          <Box sx={{ width: '100%' }}>
     
          <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
            <Grid container spacing={2}>
    
            <Grid item xs={12}>
            {required.tipo || required.data || required.medico?<p style={{color:"red"}}>controlla i campi obbligatori!</p>:""}
              </Grid>
            <Grid item xs={6}>
         
            <FormControl fullWidth>
    <InputLabel id="demo-simple-select-label">Medico</InputLabel>
    <Select
      error={required.medico}
      helperText={required.medico?"Medico obbligatorio":""}
      labelId="demo-simple-select-label"
      id="demo-simple-select"
      value={visita?visita.IDMedico:null}
      label="Medico"
      onChange={(e) =>{
        let medico = props.medici.filter(medico => medico.ID === e.target.value)[0];
        let text = medico.Nome + " " +medico.Cognome;
        let v = {...visita}
        v.IDMedico = e.target.value;
        v.Medico = text;
        setVisita(v);
      }
 }
    >
      {props.medici?.map(medico => 
 
        medico.ID!==-1?
      <MenuItem key={medico.ID} value={medico.ID}>{medico.Nome +" "+medico.Cognome}</MenuItem>:null)
      }
    </Select>
  </FormControl>
            </Grid>
            <Grid item xs={6}>
  
            <LocalizationProvider dateAdapter={DateAdapter}>
    <DateTimePicker
  
    ampmInClock={false}
      renderInput={(props) => <TextField {...props} error={required.data}/>}
      label="Data e ora"
      value={visita?visita.Data:null}
    onChange={(newValue) => {

      let v = {...visita}
        v.Data = newValue.format("YYYY-MM-DD HH:mm:SS");
        setVisita(v);
      
  
   }}
    />
  </LocalizationProvider>
    </Grid>
    <Grid item xs={12}>
            <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Mansione</InputLabel>
            <Select
              error={required.tipo}
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={visita?visita.IDMansione:null}
              label="Mansione"
              helperText={required.data?"Mansione obbligatoria":""}
              onChange={(e) =>{
                
                let text = props.mansioni.filter(mansione => mansione.ID === e.target.value)[0].Descrizione;
                let v = {...visita}
                v.IDMansione = e.target.value;
                v.Mansione = text;
                setVisita(v);
              }
         }
            >
              {props.mansioni?.map(mansione => <MenuItem key={mansione.ID} value={mansione.ID}>{mansione.Descrizione}</MenuItem>)}
            </Select>
            </FormControl>
    </Grid>
    <Grid item xs={12}>
            <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Tipologia Visita</InputLabel>
            <Select
              error={required.tipo}
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={visita?visita.TipoVisita:null}
              label="Tipologia Visita"
              helperText={required.data?"Tipologia obbligatoria":""}
              onChange={(e) =>{
                let text = props.tipologiaVisita.filter(tipologia => tipologia.ID === e.target.value)[0].Descrizione;
                let v = {...visita}
                v.TipoVisita = e.target.value;
                v.TipoVDesc = text;
                setVisita(v);
              }
         }
            >
              {props.tipologiaVisita?.map(tipologia => <MenuItem key={tipologia.ID} value={tipologia.ID}>{tipologia.Descrizione}</MenuItem>)}
            </Select>
            </FormControl>
    </Grid>
    <Grid item xs={12}>
    <div style={{ height: 400, width: '100%' }}>
    <DataGrid
        loading={accertamenti.length===0?true:false}
        disableSelectionOnClick
        checkboxSelection 
        disableColumnMenu={true}
        localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
        rows={accertamenti}
        getRowId={accertamenti => accertamenti.ID}
        columns={columns}
        selectionModel={selectionModel?.map(sel => sel.ID)}
        onSelectionModelChange={(ids) => {
          const selectedIDs = new Set(ids);
          const selectedRowData = accertamenti.filter((row) =>
            selectedIDs.has(row.ID),
          );
          console.log(selectedRowData);
          setSelectionModel(selectedRowData)
        }}
        onCellEditCommit={(params, event) => {
          let row = {...params.row};
          row[params.field] = params.value;
       
         let selAcc = [...selectionModel];
          let findIndex = selAcc.findIndex((acc => acc.ID == params.row.ID)); //trovo la posizione
          if(findIndex!==-1){
          selAcc.splice(findIndex,1);
          }
          selAcc.push(row);
          setSelectionModel(selAcc);
  
  
        }}
          
      />
        
      
  
      </div>
  
    </Grid>  
  
            <Grid item xs={12}>
            <FormControl fullWidth>
    <InputLabel id="demo-simple-select-label">Esito</InputLabel>
    <Select
      labelId="demo-simple-select-label"
      id="demo-simple-select"
      value={visita?visita.Esito:null}
      label="Esito"
      onChange={(e) =>{
        let text = props.esiti.filter(esito => esito.ID === e.target.value)[0].Descrizione;
        let v = {...visita}
        v.Esito = e.target.value;
        v.EsitoDesc=text;
        setVisita(v);
      }
 }
      
      //onChange={handleChange}
    >
      {props.esiti?.map(esito => <MenuItem key={esito.ID} value={esito.ID}>{esito.Descrizione}</MenuItem>)
      }
    </Select>
  </FormControl>
  <Grid item xs={12}>
 
  <TextField
  fullWidth
  label="Note"
  multiline
  value={visita?visita.Note:null}
  onChange={(e) =>{

    let v = {...visita}
    v.Note = e.target.value;
    setVisita(v);
  }
}
  sx={{marginTop:"20px"}}
/>
  </Grid>
            </Grid>
            </Grid>
            
      
            </Box>
      </Box>
          </DialogContent>
          <DialogActions>

            <Button onClick={handleClose} color="error">Esci</Button>
            <Button onClick={handleSave} color="success">Salva</Button>
            
          </DialogActions>
        </Dialog>
      </div>
    );
  }
  
  
  